<template>
  <div class="modal-wrapper">
    <LoaderWrapper :state="loadState" class="modal-content">
      <div :key="loadState" class="modal-header">
        <div class="modal-header-title">
          <slot name="header"></slot>
        </div>
        <div class="modal-header-close" @click="closeModal"></div>
      </div>
      <div :key="loadState" class="modal-mid">
        <div v-if="hasSlot('modal-nav')" class="modal-nav">
          <div class="fixed-container">
            <slot name="modal-nav"></slot>
          </div>
        </div>
        <slot></slot>
      </div>
      <div v-if="hasSlot('modal-footer')" :key="loadState" class="modal-footer">
        <slot name="modal-footer"></slot>
      </div>
    </LoaderWrapper>
  </div>
</template>

<script>
  import { DATA_STATES } from '@/store/consts';
  import LoaderWrapper from './loader-wrapper';

  export default {
    name: 'ihu-fullscreen-modal',
    components: {
      LoaderWrapper,
    },
    props: {
      loadState: {
        type: String,
        default: DATA_STATES.NONE,
      },
    },
    methods: {
      hasSlot(slotName) {
        return !!this.$slots[slotName];
      },
      closeModal() {
        this.$emit('closeClicked');
      },
    },
  };
</script>

<style scoped lang="scss">
  .modal-wrapper {
    position: absolute;
    top: -55px;
    left: -54px;
    padding: 0;
    height: 100vh;
    width: 100vw;
    z-index: 2000;
  }
  .modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;

    @include themify {
      background-color: getColor('setupContentBackground', 'ihu');
    }

    & > .modal-header {
      height: 52px;
      line-height: 52px;
      position: relative;
      flex-grow: 0;

      @include themify {
        background-color: getColor('ihuFullScreenModalHeader', 'ihu');
      }

      .modal-header-title {
        float: left;
        position: relative;
        left: 24px;
        font-size: 14px;
        font-style: normal;
        font-family: Roboto;

        @include themify {
          color: getColor('ihuFullScreenModalHeaderTitle', 'ihu');
        }
      }

      .modal-header-close {
        float: right;
        right: 27.1px;
        position: relative;
        height: 52px;
        width: 21px;
        cursor: pointer;
        @include themify('dark') {
          background: url('~@/components/common/assets/navigation/close_cross_dark.svg') no-repeat center;
        }
        @include themify('light') {
          background: url('~@/components/common/assets/navigation/close_cross_light.png') no-repeat center;
        }
      }
    }

    & > .modal-mid {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      overflow: auto;

      .modal-nav {
        width: 244px;
        top: 55px;
        flex-shrink: 0;

        .fixed-container {
          position: fixed;
          top: 52px;
          bottom: 0;
          width: 244px;
          z-index: 1;
        }
      }
    }

    & > .modal-footer {
      min-height: 84px;
      width: 100vw;
      flex-grow: 0;
      z-index: 1;

      @include themify {
          background-color: getColor('ihuFullScreenModalFooter', 'ihu');
      }
    }
  }
</style>

